var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "core-js/modules/es6.regexp.replace", "@babel/runtime-corejs2/core-js/json/stringify", "@babel/runtime-corejs2/core-js/promise", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "axios", "emotion-theming", "prop-types", "react", "../../../../builts/footer-labels", "../../css", "../../propTypes", "../../themes", "../../utils", "./EuropeanSection", "./LegacySection", "./MainSection", "./NextFooter.css", "./PartnerSection"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("core-js/modules/es6.regexp.replace"), require("@babel/runtime-corejs2/core-js/json/stringify"), require("@babel/runtime-corejs2/core-js/promise"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("axios"), require("emotion-theming"), require("prop-types"), require("react"), require("../../../../builts/footer-labels"), require("../../css"), require("../../propTypes"), require("../../themes"), require("../../utils"), require("./EuropeanSection"), require("./LegacySection"), require("./MainSection"), require("./NextFooter.css"), require("./PartnerSection"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.es6Regexp, global.stringify, global.promise, global.classCallCheck, global.createClass, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.axios, global.emotionTheming, global.propTypes, global.react, global.footerLabels, global.css, global.propTypes, global.themes, global.utils, global.EuropeanSection, global.LegacySection, global.MainSection, global.NextFooter, global.PartnerSection);
    global.NextFooter = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _es6Regexp2, _stringify, _promise, _classCallCheck2, _createClass2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _axios, _emotionTheming, _propTypes, _react, _footerLabels, _css, _propTypes2, _themes, _utils, _EuropeanSection, _LegacySection, _MainSection, _NextFooter, _PartnerSection) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = _exports.translate = void 0;
  _construct = _interopRequireDefault(_construct);
  _stringify = _interopRequireDefault(_stringify);
  _promise = _interopRequireDefault(_promise);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _axios = _interopRequireDefault(_axios);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireWildcard(_react);
  _footerLabels = _interopRequireDefault(_footerLabels);
  _propTypes2 = _interopRequireDefault(_propTypes2);
  _themes = _interopRequireDefault(_themes);
  _EuropeanSection = _interopRequireDefault(_EuropeanSection);
  _LegacySection = _interopRequireDefault(_LegacySection);
  _MainSection = _interopRequireDefault(_MainSection);
  _PartnerSection = _interopRequireDefault(_PartnerSection);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var translate = function translate(labels, locale) {
    return locale in labels ? labels[locale] : labels.fr;
  };

  _exports.translate = translate;

  var NextFooter = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(NextFooter, _Component);

    var _super = _createSuper(NextFooter);

    function NextFooter(props) {
      var _this;

      (0, _classCallCheck2.default)(this, NextFooter);
      _this = _super.call(this, props);
      _this.state = {
        footerData: translate(_footerLabels.default, props.locale),
        partners: props.partners || _footerLabels.default.partners
      };
      _this.currentYear = new Date().getFullYear();
      (0, _css.injectFont)('body');
      return _this;
    }

    (0, _createClass2.default)(NextFooter, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        var storageData = global.sessionStorage.getItem('ASGFooter');
        var footerData = null;

        if (storageData) {
          try {
            footerData = JSON.parse(storageData);
          } catch (error) {// console.log(error);
          }
        }

        var promise;

        if (!footerData) {
          var cdnUrl = "https://static-cdn.arte.tv/static/styleguide/4.0.4";
          var version = "4.0.4";
          var footerLabelsUrl = "".concat(cdnUrl.replace(version, 'latest'), "/assets/footer-labels.json");
          promise = _axios.default.get(footerLabelsUrl).then(function (data) {
            return data.data;
          });
        } else {
          promise = _promise.default.resolve(footerData);
        }

        promise.then(function (data) {
          if (data) {
            global.sessionStorage.setItem('ASGFooter', (0, _stringify.default)(data));
          }

          _this2.setState({
            footerData: translate(data, _this2.props.locale),
            partners: _this2.props.partners || data.partners
          });
        }).catch(function (error) {
          if (process.env.NODE_ENV === 'development') console.log(error);
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            className = _this$props.className,
            labels = _this$props.labels,
            locale = _this$props.locale,
            theme = _this$props.theme;
        var _this$state = this.state,
            footerData = _this$state.footerData,
            partners = _this$state.partners;
        var legacy = (labels && labels.legacy || footerData.legacy).replace('%YEAR%', this.currentYear);
        return /*#__PURE__*/_react.default.createElement(_emotionTheming.ThemeProvider, {
          theme: _themes.default[theme]
        }, /*#__PURE__*/_react.default.createElement(_NextFooter.StyledFooter, {
          role: "contentinfo",
          id: "next_footer",
          className: className
        }, (0, _utils.isEurope)(locale) && /*#__PURE__*/_react.default.createElement(_EuropeanSection.default, {
          label: labels && labels.european || footerData.european
        }), /*#__PURE__*/_react.default.createElement(_MainSection.default, {
          sections: labels && labels.main || footerData.main
        }), /*#__PURE__*/_react.default.createElement(_PartnerSection.default, {
          partners: partners
        }), /*#__PURE__*/_react.default.createElement(_LegacySection.default, {
          label: legacy
        })));
      }
    }]);
    return NextFooter;
  }(_react.Component);

  NextFooter.propTypes = {
    className: _propTypes.default.string,
    locale: _propTypes.default.string.isRequired,
    labels: _propTypes.default.shape({
      european: _propTypes2.default.europeanFooter,
      main: _propTypes2.default.mainFooter,
      legacy: _propTypes2.default.legacyFooter
    }),
    partners: _propTypes2.default.partnerFooter,
    theme: _propTypes.default.string
  };
  NextFooter.defaultProps = {
    className: 'row',
    locale: 'fr',
    theme: 'next'
  };
  var _default = NextFooter;
  _exports.default = _default;
});